import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProfessionService } from '../../../service/profession/profession.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteProfessionComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-profession',
  templateUrl: './autocomplete-profession.component.html',
  styleUrls: ['./autocomplete-profession.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})

export class AutocompleteProfessionComponent implements ControlValueAccessor, OnInit, OnChanges {

  @Input() professionId: number;
  // @Input() professionPosition: string;
  @Output() onMyChange = new EventEmitter();
  @Input() disabled: boolean;
  @Input() readOnly: boolean;
  @Input() placeholder: string;

  @ViewChild('input') textarea;

  public options: any[];

  public onChange;
  public onTouched;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public filters: {key: string, value: string}[];

  public sel: any;

  constructor(
    private renderer: Renderer2,
    public professionService: ProfessionService
  ) {
    this.page = 1;
    this.per_page = 10;
  }

  ngOnInit() {

  }

  public ngOnChanges() {
    this.query = undefined;
    this.filters = [];
    // this.filters.push({key: 'activated-lk', value: '1'});
    
    if (this.professionId) {
      this.filters.push({key: 'id', value: String(this.professionId)});
    }
    // if (this.professionPosition) {
    //   this.filters.push({key: 'profile-survey_position_id', value: this.professionPosition});
    // }
    this.getProfessions(this.query, this.filters);
  }

  writeValue(value: any ) {
    const div = this.textarea.nativeElement;
    // this.renderer.setProperty(div, 'textContent', value);
  }

  registerOnChange(fn: any ) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any ) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean ) {
    this.disabled = isDisabled;
  }
  // setreadonly (v) {
  //     this.readOnly =v;
  //  };
  setReadOnlyState(isReadOnly: boolean ) {
    this.readOnly = isReadOnly;
  }

  public change($event) {
    // this.onChange(this.sel);
    // this.onTouched(this.sel);
    // this.onMyChange.emit(this.sel);
    this.emitOutput(this.sel);
  }

  public loadProfessionsLazy(event) {
      // this.getProfessions(event.query);
      var str = event.query;
      var res = str.replace(/\s/g, "%");
      this.getProfessions(res);
  }

  getProfessions(query?: string, filters?: any[]) {
    this.professionService.getProfession(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
      response => {
        this.options = response.json().data;
        if (this.professionId) {
          this.professionId = undefined;
          this.sel = this.options[0];
          // this.emitOutput({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
          this.emitOutput(this.sel);
          this.filters = [];
          // this.filters.push({key: 'activated-lk', value: '1'});
          
          // if (this.professionPosition) {
          //   this.filters.push({key: 'profession_id', value: this.professionPosition});
          // }
        }
        // if (response.json().meta.total > response.json().meta.total_filtered) {
        //   this.totalRecords = response.json().meta.total_filtered;
        // } else {
        //   this.totalRecords = response.json().meta.total;
        // }
      },
      error => {
        this.options = [];
        this.options.push({id: '', name: 'Error'});
      }
    );
  }
  public emitOutput(value: any) {   
    if(value.id || value =="") {            
      this.onChange(value);
      this.onTouched(value);
      this.onMyChange.emit(value);
    }
  }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/professions/autocomplete-profession/autocomplete-profession.component.ts